/**
 * Track time and performance
 *
 * @type {PerformanceUtils}
 */
window.PerformanceUtils = new function() {

    var self = this;
    var debugKey = "PerformanceUtils";
    var startTime = initialStartTime;
    var isFirstLoad = true;
    var trackingFor;
    var partialChange;

    self.startTracking = function(toState, isPartialChange) {
        if (!startTime) {
            // console.debug(debugKey, "Tracking started: Setting start time reference");

            trackingFor = toState;
            startTime = Date.now();
            partialChange = isPartialChange;
        }
    }

    self.trackWhenUIReady = function(selector, user, state, url) {
        var now = Date.now();
        var initialServerDelay = serverDelay || 0;
        var delay = (now - startTime) + initialServerDelay;

        var checkElement = function() {
            if ($(selector).is(":visible")) {
                self.trackLoaded(user, state, url);
                clearInterval(interval);
            }
        }

        var interval = setInterval(checkElement, 100);
    }

    self.trackLoaded = function(user, state, url) {
        if (!startTime) {
            // console.debug(debugKey, "Sending track time without startTracking being called");
            // Start time not set, tracking ignored
            return;
        }

        state = (state && state.current) || state || {};
        var initialServerDelay = serverDelay || 0;
        var category = "Guests";

        // Default to state.name or Not Set, further decisions later
        var timingVar = state.name || "Not Set";

        // Remove slug name from dynamic-tempaltes
        if (state['dynamic-template'] && state.name) {
            var stateNameParts = state.name.split("_");
            timingVar = stateNameParts && stateNameParts[1];
        }

        if (partialChange) {
            timingVar = timingVar + " (partial)";
        }

        // state analytics_name has the most priority
        timingVar = state.analytics_name || timingVar;

        var label = isFirstLoad? "Direct": "Navigation";

        if (user && user.isLoggedIn()) {
            var userId = user.data && user.data.user && user.data.user.id;
            category = "Candidates";

            if (user.isEmployer()) {
                category = "Employers";
            }

            category = category + " " + userId;
        }

        var now = Date.now();
        var delay = (now - startTime) + initialServerDelay;
        var page = url || window.location.pathname;
        page = Utils.stripTrailingSlash(page) || "/";

        // Loads with more than 10 secs is considered as upnormal
        if (delay > (10 * 1000)) {
            label = label + " (Upnormal)";
        }

        // Reset is first load flag && server delay
        isFirstLoad = false;
        serverDelay = 0;


        if (trackingFor && state.name != trackingFor.name) {
            // console.debug(debugKey, "Tracking failed, started by a different state, start: " +  trackingFor.name + " now: " + state.name);
            self.reset();
            return;
        }

        var sendGoogleTiming = function() {
            if(window.ga && ga.create) {
                // console.debug(debugKey, 'Send: timing, ' + category + ', ' + timingVar + ', ' + delay + ', ' + label + ', ' + JSON.stringify({'page': page}));
                ga('send', 'timing', category, timingVar, delay, label, {'page': page});
            }
            else {
                setTimeout(sendGoogleTiming, 500);
            }
        }

        sendGoogleTiming();
        self.reset();
    }

    self.reset = function() {
        startTime = null;
        trackingFor = null;
        partialChange = false;
    }

    self.startTracking();
}